module.exports = __webpack_public_path__ + "img/logo.09786b8e.png";